export const LOCALSTORAGE_ACCESS_TOKEN = "gpa_accessToken";
export const LOCALSTORAGE_USER_INFO = "gpa_userInfo";
export const LOCALSTORAGE_USERS_LIST = "gpa_usersList";
export const LOCALSTORAGE_CURRENT_USER = "gpa_currentUser";
export const LOCALSTORAGE_EVENTS_LIST = "gpa_eventsList";
export const LOCALSTORAGE_CURRENT_EVENT = "gpa_currentEvent";
